// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"660405e9","495":"758f8615","502":"758f8615","789":"758f8615","792":"178fd035","890":"758f8615"}[chunkId] + ".chunk.css";
};